module.exports = __webpack_public_path__ + "app-static/img/wzf.c3f520fb.png";